import React from "react";
import { InView } from 'react-intersection-observer'; // Import Intersection Observer
import { 
  PencilIcon, 
  PhotographIcon, 
  DocumentDuplicateIcon, 
  ShareIcon, 
  DesktopComputerIcon, 
  DownloadIcon, 
  CogIcon 
} from "@heroicons/react/outline"; // Heroicons

const KeyFeatures = () => {
  const features = [
    {
      icon: <PencilIcon className="w-12 h-12 text-purple-700" />,
      title: "Easy-to-Use Editor",
      description: "Create and edit stunning posters and business cards with our user-friendly editor.",
    },
    {
      icon: <PhotographIcon className="w-12 h-12 text-purple-700" />,
      title: "Image Upload & Customization",
      description: "Upload your images, logos, and customize designs with ease to suit your needs.",
    },
    {
      icon: <DocumentDuplicateIcon className="w-12 h-12 text-purple-700" />,
      title: "Template Library",
      description: "Choose from a wide range of templates for posters, business cards, and more.",
    },
    {
      icon: <ShareIcon className="w-12 h-12 text-purple-700" />,
      title: "Easy Sharing",
      description: "Share your designs directly via email, social media, or generate shareable links.",
    },
    {
      icon: <DesktopComputerIcon className="w-12 h-12 text-purple-700" />,
      title: "Multi-Platform Access",
      description: "Design and download your creations on both desktop and mobile devices, anytime, anywhere.",
    },
    {
      icon: <DownloadIcon className="w-12 h-12 text-purple-700" />,
      title: "Download in High Quality",
      description: "Download your designs in high resolution, ready for printing or digital use.",
    },
    {
      icon: <CogIcon className="w-12 h-12 text-purple-700" />,
      title: "Customizable Settings",
      description: "Adjust the design preferences according to your brand or personal style.",
    },
  ];

  return (
    <div className="bg-gray-50 min-h-screen py-16 shadow-lg">
      <div className="container mx-auto px-6 text-center">
        <h2 className="text-3xl font-bold text-gray-800 mb-6">Key Features</h2>
        <p className="text-lg text-gray-600 mb-12">
          Explore the powerful features of **EDIT EZY**, designed to simplify poster and business card creation!
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <InView
              key={index}
              triggerOnce={true}  // Trigger animation once when element comes into view
              threshold={0.5}      // Trigger when 50% of the element is visible
            >
              {({ inView, ref }) => (
                <div
                  ref={ref}
                  className={`bg-white shadow-xl rounded-lg p-6 flex flex-col items-center text-center transform transition-transform hover:-translate-y-2 ${inView ? 'animate__animated animate__fadeInUp' : ''}`}
                >
                  {feature.icon}
                  <h3 className="text-xl font-semibold text-gray-800 mt-4">{feature.title}</h3>
                  <p className="text-gray-600 mt-2">{feature.description}</p>
                </div>
              )}
            </InView>
          ))}
        </div>
      </div>
    </div>
  );
};

export default KeyFeatures;
